import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './AuthShell.css';

interface Props {
  readonly title: string;
  readonly subtitle?: string;
  /** Navigation pinned to the very top of the panel, above the title — e.g. the
   *  Create-account / Sign-in mode toggle — so switching modes is visible
   *  without scrolling past a long form. */
  readonly topNav?: ReactNode;
  readonly children: ReactNode;
  readonly footer?: ReactNode;
}

// Shared chrome for every /auth/* page. Phase 3 polishes this with the
// octagon HUD; Phase 1 keeps it as a simple framed panel so route stubs
// have a consistent look.
export default function AuthShell({ title, subtitle, topNav, children, footer }: Props) {
  return (
    <div className="om-auth-shell">
      <Link to="/" className="om-auth-shell__home">
        ← OculusMind.AI
      </Link>
      <div className="om-auth-shell__panel" role="region" aria-label={title}>
        {topNav}
        <h1 className="om-auth-shell__title">{title}</h1>
        {subtitle ? <p className="om-auth-shell__subtitle">{subtitle}</p> : null}
        <div className="om-auth-shell__body">{children}</div>
        {footer ? <div className="om-auth-shell__footer">{footer}</div> : null}
      </div>
    </div>
  );
}
